/**
 * English locale for main navigation (sidebar + user menu)
 */

export const en = {
  adminDashboard: 'Admin Dashboard',
  searchPlaceholder: 'Search...',
  createLeads: 'Create Leads',
  motorPolicy: 'Motor Policy',
  voluntaryInsurance: 'Voluntary Insurance',
  leads: 'Leads',
  policyInProgress: 'Policy In Progress',
  compulsoryInsurance: 'Compulsory Insurance',
  endorsement: 'Endorsement',
  nonMotorPolicy: 'Non-Motor Policy',
  nonMotor: 'Non-Motor',
  nonStandardLeads: 'Non-Standard Leads',
  nonStandardPolicies: 'Non-Standard Policies',
  motorbike: 'Motorbike',
  agents: 'Agents',
  allAgents: 'All Agents',
  mlmAgents: 'MLM Agents',
  cmiSubagents: 'CMI Subagents',
  eventCalendar: 'Event Calendar',
  commission: 'Commission',
  downloadDocuments: 'Download Documents',
  agentTransfers: 'Agent Transfers',
  commissions: 'Commissions',
  dashboard: 'Dashboard',
  referrals: 'Referrals',
  leadGenerationCodes: 'Lead Generation Codes',
  debtCollectionCRM: 'Debt Collection CRM',
  accounting: 'Accounting',
  agent: 'Agent',
  insurer: 'Insurer',
  instalments: 'Installment',
  credits: 'Credits',
  uploadWHTCertificate: 'Upload WHT Certificate',
  insurerTables: 'Insurer Tables',
  priceListAdmin: 'Price List Admin',
  preQuoteSLA: 'Pre-Quote SLA',
  promotionAdmin: 'Promotion Admin',
  packagePromotion: 'Package Promotion',
  campaignPromotion: 'Campaign Promotion',
  policyAdmin: 'Policy Admin',
  mtiCovidPolicy: 'MTI Covid Policy',
  vibCovidPolicy: 'VIB Covid Policy',
  policyTrackingIds: 'Policy Tracking IDs',
  cancellationTrackingIds: 'Cancellation Tracking IDs',
  gamificationAdmin: 'Gamification Admin',
  staffManagement: 'Staff Management',
  manageStaff: 'Manage Staff',
  staffTiming: 'Staff Timing',
  manageLeave: 'Manage Leave',
  uploadSupportStaffCSV: 'Upload Support Staff CSV',
  teamList: 'Team List',
  insurerSetting: 'Insurer Setting',
  insurerEmail: 'Insurer Email',
  insurerToggles: 'Insurer Toggles',
  nonMotorInsurerEmail: 'Non Motor Insurer Email',
  refundRules: 'Refund Rules',
  bannerUpload: 'Banner Upload',
  highlightUpload: 'Highlight Upload',
  announcementUpload: 'Announcement Upload',
  commissionHighlight: 'Commission Highlight',
  promotionHighlight: 'Promotion Highlight',
  announcementInventory: 'Announcement Inventory',
  holidays: 'Holidays',
  printingAndDelivery: 'Printing and Delivery',
  crm: 'CRM',
  crmAffiliate: 'CRM Affiliate',
  staffForTask: 'Staff for Tasks',
  generateTrackableLink: 'Generate Trackable Link',
  generateShortenedURL: 'Generate Shortened URL',
  historicalReportRequests: 'Historical Report Requests',
  csvUpload: 'CSV Upload',
  irSettings: 'IR Settings',
  preSaleSLA: 'Pre-Sale SLA',
  policyIssuanceSLA: 'Policy Issuance SLA',
  coaForm: 'COA Form',
  insurerTier: 'Insurer Tier',
  affiliateSpecificCommissionRates: 'Affiliate Specific Commission Rates',
  insurerRanking: 'Insurer Ranking',
  commissionPromotions: 'Commission & Promotions',
  chatwootPayments: 'Chatwoot Payments',
  assignmentConfig: 'Assignment Config',
  notificationsAdmin: 'Notifications',
  profile: 'Profile',
  logout: 'Log Out',
  language: 'Language',
  theme: 'Theme',
  themeLight: 'Light',
  themeDark: 'Dark',
};
